import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconScanCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconScanCode"><Path d="M7 9H8V15H7V9Z" fill="currentColor"/><Path d="M9 9H11V15H9V9Z" fill="currentColor"/><Path d="M12 9H13V15H12V9Z" fill="currentColor"/><Path d="M16 9H17V15H16V9Z" fill="currentColor"/><Path d="M14 9H15V15H14V9Z" fill="currentColor"/><Path d="M9 3.5H3.5V9" stroke="currentColor"/><Path d="M9 20.5H3.5V15" stroke="currentColor"/><Path d="M15 3.5H20.5V9" stroke="currentColor"/><Path d="M15 20.5H20.5V15" stroke="currentColor"/></CentralIconBase>;
});

export default IconScanCode;
